/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `standard` - CASCO "STANDARD"
 * * `comfort` - CASCO "CONFORT"
 * * `fifty_fifty` - CASCO "50/50"
 * * `mini` - CASCO "MINI"
 */
export enum CascoPackage {
  STANDARD = 'standard',
  COMFORT = 'comfort',
  FIFTY_FIFTY = 'fifty_fifty',
  MINI = 'mini',
}
